module.exports = __webpack_public_path__ + "img/pr_gspt1-e1500450055822-291x300.e401eb71.png";